export function getdata() {
    let obj = {
        dealDataList: [
            { id: 'add_deal_0' }
        ],
        matchDataList: [
            { id: 'add_match_0' }
        ],
        rangeDataList: [
            { label: '中间取', value: '00' },
            { label: '向后取', value: '01' }
        ]
    };
    return obj;
}
